import React from 'react';

import styled from 'styled-components';

import { useActiveToc } from 'hooks/common/useTocNavigation';

import theme from 'styles/token/color';
import { typography } from 'styles/token/typography';

const TocNavigation = () => {
  const { title, items, activeId, scrollToSection, scrollToTop } =
    useActiveToc();

  // items가 없거나, 첫 번째 항목에 id가 없는 경우 미표출
  if (!items?.[0]?.id) return null;

  return (
    <TocNavigationWrap>
      <TocNav>
        {/* api 타이틀명 */}
        <TocTop onClick={scrollToTop}>{title}</TocTop>
        {/* api 컨텐츠 리스트 */}
        <TocList>
          {items.map((item) => (
            <TocItem
              key={`toc-${item.id}`}
              onClick={() => scrollToSection(item.id)}
              className={activeId === item.id ? 'active' : ''}
            >
              <a href={item.href} onClick={(e) => e.preventDefault()}>
                {item.label}
              </a>
            </TocItem>
          ))}
        </TocList>
      </TocNav>
    </TocNavigationWrap>
  );
};

export default TocNavigation;

const TocNavigationWrap = styled.div`
  flex: 0 0 216px;
  width: 100%;
  min-width: 216px;
  margin: 0 24px 32px 24px;
  padding-left: 24px;
`;

const TocNav = styled.nav`
  position: sticky;
  top: 90px;
  height: fit-content;
`;

const TocTop = styled.div`
  color: ${theme.color.gray800};
  ${typography.labelLarge}
  font-weight: 400;
  cursor: pointer;
  line-height: 40px;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: ${theme.color.primary};
  }
`;

const TocList = styled.ul`
  display: flex;
  flex-direction: column;
  margin: 0 4px 6px 4px;
  border-left: 1px solid ${theme.color.gray100};
`;

const TocItem = styled.li`
  position: relative;
  cursor: pointer;
  padding: 5px 8px 5px 16px;

  a {
    ${typography.labelLarge}
    color: ${theme.color.gray400};
    font-weight: 300;
    transition: color 0.2s ease-in-out;
  }

  &:hover {
    background: ${theme.color.gray80};
    border-radius: 0 6px 6px 0;

    a {
      color: ${theme.color.gray700};
    }
  }

  &.active {
    &:before {
      content: '';
      position: absolute;
      left: -1px;
      top: 50%;
      transform: translateY(-50%);
      display: inline-block;
      height: 32px;
      border-left: 1px solid ${theme.color.primary};
    }
    a {
      color: ${theme.color.primary};
    }
  }
`;
